var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutstanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 128.5,
    cy: 128.5,
    r: 117.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.1,101.1c0-5.7,4.7-10.4,10.4-10.4s10.4,4.7,10.4,10.4c0,5.7-4.7,10.4-10.4,10.4S171.1,106.9,171.1,101.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.7,148.2c-8.4,27-33.5,46.5-63.2,46.5s-54.8-19.6-63.2-46.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70.3,
    y1: 145.3,
    x2: 58.2,
    y2: 151.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 186.7,
    y1: 145.3,
    x2: 198.8,
    y2: 151.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.8,107.1c2.5-4.4,7.2-7.3,12.6-7.3c5,0,9.5,2.6,12.1,6.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstanding);
export default __webpack_public_path__ + "static/media/Outstanding.a1460d3bd209bf778c5d63e437761be7.svg";
export { ForwardRef as ReactComponent };